
import {Options, Vue} from "vue-class-component";
import {useRoute} from "vue-router";
import ModuleClients from "@/store/clients";
import {FullClientInfoDto} from "@/types/clientDetails";
import {AppointmentDto} from "@/types/appointments";
import ModuleAppointments from "@/store/appointments";
import {getRowColor, getPaymentStatusColor, getAppointmentStatusColor} from "@/utils/color-utils";
import {format} from "date-fns";
import 'vue3-swatches/dist/style.css'
import rules from "@/utils/rules";


export default class ClientDetails extends Vue {
    private loading: boolean = false;
    // значение по умолчанию нужно, чтобы Vue смог связать биндинг до того, как сработает метод mounted и проинициализирует реальными данными
    private client: FullClientInfoDto = {
        clientId: '',
        name: '',
        notes: '',
        color: '',
        objectives: [],
        progress: [],
        active: false,
        activity: [],
        nextAppointment: null,
        allowToViewHealthData: false
    };

    private clientAppointments: AppointmentDto[] = [];
    private headers: any = [
        { title: 'Start', key: 'slot' },
        { title: 'End', key: 'endTime' },
        { title: 'Appointment status', key: 'status', filter: value => {
                if (!this.appointmentStatus) return true;
                return value === this.appointmentStatus
            } },
        { title: 'Payment status', key: 'paymentStatus', filter: value => {
                if (!this.paymentStatus) return true;
                return value === this.paymentStatus
            } },
        { title: 'Action', key: '' },
        { title: '', key: 'appointmentDate', filter: value => {
                return !(!this.showPreviousAppointments && value.localeCompare(format(new Date(), "yyyy-MM-dd")) < 0 );

            } },
    ];
    private groupBy: any = [
        {
            key: 'appointmentDate',
            order: 'asc',
        },
    ];
    private showPreviousAppointments: boolean = true;
    private appointmentStatuses: any = [
        { title: "REQUESTED", value: "REQUESTED" },
        { title: "SCHEDULED", value: "SCHEDULED" },
        { title: "RESCHEDULED", value: "RESCHEDULED" },
        { title: "COMPLETED", value: "COMPLETED" },
        { title: "MISSED", value: "MISSED" },
        { title: "CANCELLED", value: "CANCELLED" },
        { title: "CANCELLED", value: "CANCELLED" },
    ]
    private appointmentStatus: string = "";
    private paymentStatuses: any = [
        { title: "PAYMENT_REQUESTED", value: "PAYMENT_REQUESTED" },
        { title: "PAID", value: "PAID" },
        { title: "REFUNDED", value: "REFUNDED" },
        { title: "CANCELLED", value: "CANCELLED" },
        { title: "FAILED", value: "FAILED" },
        { title: "FREE", value: "FREE" },
        { title: "UNKNOWN", value: "UNKNOWN" },
    ]
    private paymentStatus: string = "";
    private search: string = "";
    private filtersDialog: boolean = false;
    private valid: boolean = false;
    private nameRules: any = [
        rules.required
    ]

    private tab: string | null = "Notes";
    private text: string = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.';
    async mounted() {
        const route = useRoute();
        const clientId =  route.params.id as string;
        const queryTab = route.query.tab as string;
        // в mounted грузим с сервера данные, нужные для отображения View и помещаем их в поля
        // так как мы задали полям значение по умолчанию, Vue связал биндинги с полями и теперь
        // на изменение поля он сделает повторную отрисовку
        this.client = await ModuleClients.getClientByClientId(clientId);
        this.clientAppointments = await ModuleAppointments.getAllAppointmentByClientId(clientId);
        if (queryTab == "appointment" && this.client.nextAppointment != null) {
            this.tab = 'Appointment';
        }
        else {
            this.tab = "Notes";
        }
    }
    onClearFilters() {
        this.search = '';
        this.showPreviousAppointments = false;
        this.appointmentStatus = "";
        this.paymentStatus = "";
    }

    async onSetNotes() {
        this.loading = true;
        await ModuleClients.setNotes(this.client);
        this.loading = false;
    }

    async onUpdateClientInfo() {
        this.loading = true;
        try {
            let updatedClientInfo = await ModuleClients.updateClientInfo(this.client)
            this.client.name = updatedClientInfo.name
            this.client.color = updatedClientInfo.color
            this.client.objectives = updatedClientInfo.objectives

            const notification = (this[`$notify`] as any).success(
                "Saved successfully"
            )

            setTimeout(() => {
                notification.close();
            }, 1000);
        }
        catch (error) {
            const notification = (this[`$notify`] as any).error(
                "Failed to save"
            )

            setTimeout(() => {
                notification.close();
            }, 1000);
        }
        finally {
            this.loading = false;
        }
    }

    getRowColor(appointment: AppointmentDto): string {
        return getRowColor(appointment);
    }

    getPaymentStatusColor(paymentStatus: string): string {
        return getPaymentStatusColor(paymentStatus);
    }

    getAppointmentStatusColor(appointmentStatus: string): string {
        return getAppointmentStatusColor(appointmentStatus);
    }

    async onUpdate(appointment: AppointmentDto) {
        this.loading = true;
        try {
            let updatedAppointment = await ModuleAppointments.updateAppointment(appointment);
            let foundIndex = this.clientAppointments.findIndex((value, index, obj) => {
                return value.appointmentId === updatedAppointment.appointmentId
            })

            if (foundIndex !== -1) {
                this.clientAppointments[foundIndex] = updatedAppointment
            }

            const notification = (this[`$notify`] as any).success(
                "Saved successfully"
            )

            setTimeout(() => {
                notification.close();
            }, 3000);
        }
        catch (error) {
            const notification = (this[`$notify`] as any).error(
                "Failed to save"
            )

            setTimeout(() => {
                notification.close();
            }, 3000);
        }
        finally {
            this.loading = false;
        }
    }
}
